import { Avatar, Box, Typography, useMediaQuery } from "@mui/material";
import { formatPrice } from "../../utils";
import { useTheme } from "@emotion/react";
import { fileApiRoute } from "../../services/networkService";

const TopThreeCard = ({ list, label, color }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box
            sx={{
                bgcolor: 'white',
                boxShadow: 1,
                border: 1,
                borderColor: theme.palette.customGrey.borderInput,
                backgroundColor: 'white',
                borderRadius: 1,
                p: 2,
                width: isMobile ? '100%' : '32%',
                height: 300
            }}>

            <Typography id="transition-modal-title" variant="subtitle1" color={theme.palette.customGrey.text}>
                {label}
            </Typography>

            <Box mt={4}>
                {list?.map((person) =>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                        key={person.id}
                        width={'100%'}
                        mb={3}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                            <Avatar src={`${fileApiRoute}/${person.image}`} sx={{ width: 40, height: 28 }} variant="square" />
                            <Box width={'8px'}></Box>
                            <Typography id="transition-modal-title" variant="subtitle1">
                                {person.name}
                            </Typography>
                        </Box>

                        <Box sx={{
                            display: 'flex',
                            width: '50%',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                            <Box width={'20%'} sx={{
                                justifyItems: 'center',
                            }}>
                                <Typography id="transition-modal-title" variant="subtitle2" color={theme.palette.customGrey.text}>
                                    {formatPrice(person.totalPosts)}
                                </Typography>
                            </Box>
                            <Box
                                sx={{
                                    width: "55%",
                                    height: 7,
                                    borderRadius: 6,
                                    backgroundColor: theme.palette.secondary.main,
                                    overflow: "hidden",
                                }}
                            >
                                <Box
                                    sx={{
                                        width: `${person.percentage}%`,
                                        height: "100%",
                                        backgroundColor: color,
                                        transition: "width 0.3s ease-in-out",
                                        borderRadius: 6,
                                    }}
                                />
                            </Box>
                            <Box width={'20%'} sx={{
                                justifyItems: 'center',
                            }}>
                                <Typography id="transition-modal-title" variant="subtitle2" color={theme.palette.customGrey.text}>
                                    {person.percentage}%
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                )}
            </Box>


        </Box >);
}

export default TopThreeCard;